"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const ErrorIcon = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 82, height: 82, fill: "none" }, props),
    React.createElement("g", { filter: "url(#a)" },
        React.createElement("path", { fill: "#F44336", fillRule: "evenodd", d: "M41 74c19.33 0 35-15.67 35-35S60.33 4 41 4 6 19.67 6 39s15.67 35 35 35Z", clipRule: "evenodd" })),
    React.createElement("path", { fill: "#fff", d: "m38.721 59.83-17.55-17.551c-1.561-1.56-1.561-3.998 0-5.558l17.55-17.55c1.56-1.561 3.998-1.561 5.558 0l17.55 17.55c1.561 1.56 1.561 3.998 0 5.558l-17.55 17.55c-1.56 1.561-4.095 1.561-5.558 0Z" }),
    React.createElement("path", { fill: "#F44336", d: "M39.11 48.03c0-.292.098-.584.196-.877.097-.292.292-.487.487-.682.195-.195.488-.39.78-.488.293-.097.585-.195.975-.195s.683.098.975.195c.293.098.585.293.78.488.195.195.39.39.488.682.097.293.195.585.195.878 0 .292-.098.585-.195.877-.098.293-.293.488-.488.683-.195.195-.487.39-.78.487-.292.098-.585.195-.975.195s-.682-.097-.975-.195c-.292-.097-.487-.292-.78-.487-.195-.195-.39-.39-.487-.683-.098-.292-.195-.487-.195-.877Zm4.096-4.484h-3.51l-.488-14.724h4.485l-.487 14.724Z" }),
    React.createElement("defs", null,
        React.createElement("filter", { id: "a", width: 82, height: 82, x: 0, y: 0, colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse" },
            React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
            React.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            React.createElement("feOffset", { dy: 2 }),
            React.createElement("feGaussianBlur", { stdDeviation: 3 }),
            React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" }),
            React.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_166_4244" }),
            React.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_166_4244", result: "shape" })))));
exports.default = ErrorIcon;
//# sourceMappingURL=ErrorIcon.js.map